<template>
    <v-stepper-header>
      <v-stepper-item
        value="1"
        title="Select Schedule"
        :complete="currentStep > 1"
      />
      <v-divider />
      <v-stepper-item
        value="2"
        title="Upload File"
        :complete="currentStep > 2"
        :disabled="currentStep < 2"
      />
      <v-divider />
      <v-stepper-item
        value="3"
        title="Review Structure"
        :disabled="currentStep < 3"
      />
    </v-stepper-header>
  </template>
  
  <script setup>
  defineProps({
    currentStep: {
      type: String,
      required: true
    }
  });
  </script>